/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FinancialPerformanceStatistic } from './financialPerformanceStatistic';


export interface FinancialPerformance { 
    aggregate_gross_rent?: FinancialPerformanceStatistic;
    aggregate_tourist_tax?: FinancialPerformanceStatistic;
    aggregate_ota_fee_rent?: FinancialPerformanceStatistic;
    aggregate_ota_fee_tourist_tax?: FinancialPerformanceStatistic;
    aggregate_payment_charge?: FinancialPerformanceStatistic;
    aggregate_vh_service_charge?: FinancialPerformanceStatistic;
    aggregate_owner_share?: FinancialPerformanceStatistic;
    aggregate_maintenance_expenses?: number;
    owner_payment_amount?: FinancialPerformanceStatistic;
}

